import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { toI18n } from 'util/i18n';

interface DeclineInterviewModalProps {
  candidateFirstName: string;
}

const DeclineInterviewModal = ({
  candidateFirstName,
}: DeclineInterviewModalProps) => (
  <Box>
    <Text>
      {toI18n(
        'hiring.candidates_review.detail_view.modals.send_link_to_schedule_text',
        { props: { candidate_name: candidateFirstName } }
      )}
    </Text>
  </Box>
);

export default DeclineInterviewModal;
